'use client';

import type { Link } from '@/app/(webapp)/_i18n/navigation';
import AppButton from './app-button';

type LocalizedHref = React.ComponentProps<typeof Link>['href'];

interface CtaProps {
    title?: string;
    ctaLabel: string;
    href?: LocalizedHref;
    externalUrl?: string;
}

export default function Cta({ title, ctaLabel, href, externalUrl }: CtaProps) {
    return (
        <div className="flex flex-col items-center">
            {title ? <p className="pb-7 text-lg">{title}</p> : null}
            {externalUrl ? (
                <AppButton innerText={ctaLabel} variant="primary" externalUrl={externalUrl} />
            ) : href ? (
                <AppButton innerText={ctaLabel} variant="primary" href={href} />
            ) : null}
        </div>
    );
}
